import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './InnerPage.css';

const COPY = {
  ru: {
    title: 'Страница не найдена',
    text: 'Проверьте адрес или вернитесь на главную страницу AgroLlama.',
    link: 'Вернуться на главную',
  },
  kz: {
    title: 'Бет табылмады',
    text: 'Мекенжайды тексеріңіз немесе AgroLlama басты бетіне оралыңыз.',
    link: 'Басты бетке оралу',
  },
  en: {
    title: 'Page not found',
    text: 'Check the address or return to the AgroLlama home page.',
    link: 'Return home',
  },
};

export default function NotFoundPage() {
  const { language, pathFor } = useLanguage();
  const copy = COPY[language];

  return (
    <div className="inner-page">
      <Navbar />
      <section className="inner-page__hero">
        <div className="inner-page__hero-inner">
          <div className="inner-page__tag">404</div>
          <h1 className="inner-page__title">{copy.title}</h1>
          <p className="inner-page__subtitle">{copy.text}</p>
          <Link to={pathFor('home')} className="btn btn--primary">
            {copy.link}
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}

